import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import * as styles from 'src/tables/ListingTable/ListingTable.css';
import { CountRollupMetrics } from 'src/tables/ListingTable/RollupMetrics/RollupMetrics';

type ListingTableGroupHeaderProps = {
  groupName: string;
  soldTickets: number;
};

export const ListingTableGroupHeader = ({
  groupName,
  soldTickets,
}: ListingTableGroupHeaderProps) => {
  return (
    <Stack
      justifyContent="spaceBetween"
      className={styles.groupedRowHeader}
      style={{ minWidth: 0, overflow: 'hidden' }}
    >
      <Stack
        alignItems="center"
        gap="s"
        style={{
          flexShrink: 1,
          minWidth: 0,
          overflow: 'hidden',
        }}
      >
        <CountRollupMetrics count={soldTickets} />
        <span
          style={{
            fontSize: vars.typography.fontSize.sm,
            whiteSpace: 'nowrap',
          }}
        >
          {groupName}
        </span>
      </Stack>
    </Stack>
  );
};
